import React, { useEffect } from "react";
import { useCookies } from 'react-cookie';
import { Redirect } from "react-router-dom";
import {useParams}  from "react-router-dom";

import qs from 'query-string';


const TrackingPage = (props)=> {

  const { networkId }         = useParams();
  const [_cookies, setCookie] = useCookies();

  const value = { ...qs.parse(props.location.search), networkId };

  useEffect(()=> {
    setCookie("postbackTracking", value, {
      expires : new Date(new Date().setDate(new Date().getDate() + 30)), // in 30 days
      domain: process.env.REACT_APP_COOKIE_DOMAIN,
      path    : "/",
      sameSite: 'lax',
      secure: true,
    });
  }, []);

  return (
    <Redirect to="/join" />
  );
};

export default TrackingPage;
